import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, useBreakpointValue } from "@gemini/core";
import { Modal } from "@gemini/ui";
import { useIsLandscape, useKeyboardNav } from "@/hooks";
import { Carousel, ModalTopBar } from "@/components/UI";
import { useI18n } from "@/shared/hooks";
import { SocialAndPrintCTAs } from "@/shared/components/SocialAndPrintCTAs";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
import { useGalleryContext } from "@/gallery/contexts";
import { useImages } from "@/gallery/hooks";
import { StickyCta } from "@/components/contacting";
export const SliderModal = ({ isOpen, testId }) => {
    const { t } = useI18n();
    const [showControls, setShowControls] = useState(true);
    const { activeTab, updateTab, isMasonryModalOpen, closeMasonryModal, toggleSliderModal, closeSliderModal, openMasonryAndReplace, galleryCount, carouselItems, initialStepIndex, } = useGalleryContext();
    const { imagesCount } = useImages();
    const breakpoint = useBreakpointValue({
        base: "base",
        md: "md",
        sm: "sm",
        xs: "xs",
    });
    useEffect(() => {
        if (isOpen) {
            setShowControls(true);
        }
    }, [isOpen]);
    const isMobile = breakpoint === "sm" || breakpoint === "xs" || breakpoint === "base";
    const isLandscape = useIsLandscape();
    const backToMasonry = () => {
        closeSliderModal();
        if (activeTab === TAB_ITEMS.IMAGES && imagesCount > 3) {
            if (!isMasonryModalOpen) {
                openMasonryAndReplace();
            }
        }
        // reset position to image tab if there are more than one image
        if (activeTab !== TAB_ITEMS.IMAGES && imagesCount > 1) {
            if (isMasonryModalOpen)
                closeMasonryModal();
            updateTab(TAB_ITEMS.IMAGES);
        }
    };
    const handleScreenPress = () => {
        if (isMobile || isLandscape) {
            setShowControls((showControls) => !showControls);
        }
    };
    useKeyboardNav({
        handleEscape: isOpen ? backToMasonry : undefined,
    });
    if (galleryCount < 1)
        return null;
    return (_jsx(Modal, { displayMode: "fullscreen", hasContentPadding: false, hasCloseButton: false, isOpen: isOpen, trigger: () => null, onOpenChange: toggleSliderModal, isKeyboardDismissDisabled: true, children: _jsxs(Box, { height: "100%", backgroundColor: "color.background.constant.black", position: "relative", display: "flex", flexDirection: "column", overflow: "hidden", children: [_jsx(ModalTopBar, { testId: `${testId}.TopBar`, closeAction: backToMasonry, buttonLabel: t("gallery.modal.back.cta"), variant: "dark", additionalCTAs: _jsx(SocialAndPrintCTAs, { dark: true }), closeIcon: "close", showControls: showControls, showContacting: true, tracking: {
                        avZone: "image_fullscreen",
                    } }), _jsx(Carousel, { medias: carouselItems, onScreenPress: handleScreenPress, showControls: showControls, testId: `${testId}.Fullscreen`, initialStepIndex: initialStepIndex, mediasType: activeTab }), showControls && (_jsx(StickyCta, { tracking: { avZone: "image_fullscreen" }, variant: "dark" }))] }) }));
};
